var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgChart(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#466dec;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1886",
    "data-name": "Group 1886"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Path_222",
    "data-name": "Path 222"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M41.49,94a35.94,35.94,0,0,1,0-71.88,3,3,0,0,1,3,3V55.06H74.43a3,3,0,0,1,3,3A36,36,0,0,1,41.49,94Zm-3-65.73A29.94,29.94,0,1,0,71.28,61.06H41.49a3,3,0,0,1-3-3Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path_223",
    "data-name": "Path 223"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M91.45,44.94H58.51a3,3,0,0,1-3-3V9a3,3,0,0,1,3-3h0A36,36,0,0,1,94.45,41.94,3,3,0,0,1,91.45,44.94Zm-29.94-6H88.3A30,30,0,0,0,61.51,12.15Z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChart);
export default __webpack_public_path__ + "static/media/Chart.40ada34cb4f3fdc5c0d230addd758184.svg";
export { ForwardRef as ReactComponent };